import Immutable from 'immutable';

export const enforceElementsOrder = source => {
  return Immutable.Seq(source)
    .sortBy(e => e.order)
    .map((element, index) => ({
      ...element,
      order: index,
    }))
    .toList();
};

export const reorderElements = (source, element, newOrder) => {
  const currentOrder = element.order;

  const reordered = source.map(element => {
    if (element.order === currentOrder) {
      return {
        ...element,
        order: newOrder,
      };
    } else if (element.order >= newOrder && element.order < currentOrder) {
      return {
        ...element,
        order: element.order + 1,
      };
    } else if (element.order <= newOrder && element.order > currentOrder) {
      return {
        ...element,
        order: element.order - 1,
      };
    } else {
      return element;
    }
  });

  return enforceElementsOrder(reordered);
};



// WEBPACK FOOTER //
// ./src/utils/ordering.js